/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'attatchments': {
    width: 11,
    height: 12,
    viewBox: '0 0 11 12',
    data: '<path pid="0" _fill="#848484" fill-rule="evenodd" d="M8.654.5a2.53 2.53 0 0 0-1.655.595h-.018L5.73 2.252l-.847.744L.949 6.533c-1.265 1.111-1.265 2.97 0 4.134 1.264 1.111 3.315 1.111 4.58 0l4.778-4.348-.825-.726-4.58 4.114-.148.115c-.022.053-.05.047-.072.1-.844.687-2.123.687-2.907 0-.783-.74-.778-1.905 0-2.645l.074-.05.129-.164.846-.745L5.709 3.74l.662-.596.185-.148 1.25-1.174h.018c.462-.37 1.201-.37 1.656 0a1.045 1.045 0 0 1 0 1.537L8.046 4.633l-1.067.959-.422.363-.865.794-1.012.892a.296.296 0 0 1-.404 0c-.115-.105-.115-.257 0-.363L6.15 5.592l.405-.38 1.25-1.108-.827-.744-1.25 1.108-.424.38-1.858 1.685H3.43c-.568.53-.556 1.324.018 1.853.585.53 1.476.53 2.06 0h.02l.624-.53L7.806 6.32l2.5-2.214h.02c.907-.847.896-2.163-.02-3.01A2.523 2.523 0 0 0 8.653.502V.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/attatchments.js